import { render } from "./AppearanceTypeDetail.vue?vue&type=template&id=079f31eb&scoped=true&ts=true"
import script from "./AppearanceTypeDetail.vue?vue&type=script&lang=ts"
export * from "./AppearanceTypeDetail.vue?vue&type=script&lang=ts"

import "./AppearanceTypeDetail.vue?vue&type=style&index=0&id=079f31eb&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079f31eb"]])

export default __exports__